import styled, { css } from 'styled-components';
import { media, colors, layout } from '@prisjakt/ui-base';

const searchHeight = layout.searchBar.height.desktop.value;
const searchHeightMobile = layout.searchBar.height.mobile.value;
const searchBorderWidth = layout.searchBar.borderWidth;
const boxShadowStyle = '0px 6px 10px 0px rgba(0, 0, 0, 0.2)';

export const ShopSearch = styled.div`
  padding: ${layout.spacing.medium};
  background: ${p => p.theme.buttons.primary.bg};
  border-radius: 8px;
  display: grid;
  grid-template-columns: 1.25fr 2fr;
  column-gap: ${layout.spacing.xSmall};
  margin: ${layout.spacing.xSmall};

  ${media.mediumDown`
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    gap: ${layout.spacing.xSmall};
  `};
`;

export const Text = styled.div`
  color: #fff;

  p {
    margin-bottom: 0;
  }
`;

export const Title = styled.h3`
  font-weight: normal;
`;

type SearchInputProps = {
  searchIsOpen: boolean;
};

export const SearchInput = styled.div<SearchInputProps>(
  props => css`
    width: 100%;
    border: ${layout.searchBar.borderWidth}px solid ${colors.lightBlue1};
    overflow: hidden;
    border-bottom: ${layout.searchBar.borderWidth}px solid ${colors.lightBlue1};
    border-radius: 5px;

    &,
    & > div {
      ${props.searchIsOpen &&
        css`
          border-bottom: none;
          border-radius: 5px 5px 0px 0px;
        `}
    }
  `
);

type SearchResultProps = {
  showFloatingResult: boolean;
  searchIsOpen: boolean;
};

export const SearchResult = styled.div<SearchResultProps>(
  props => css`
    position: relative;
    background: ${colors.white};
    border-radius: 0px 0px 5px 5px;
    overflow: hidden;
    text-align: left;

    ${props.showFloatingResult &&
      css`
        position: absolute;
        left: 0;
        right: 0;
        border: none;
        border-top: none;
        z-index: 10;
        box-shadow: ${boxShadowStyle};

        ${props.searchIsOpen &&
          css`
            border: 1px solid ${colors.lightBlue1};
            border-top: none;
          `}

        ${media.smallOnly`
          top: ${`${searchHeightMobile}px`};
        `};

        ${media.mediumOnly`
          top: ${searchHeight + searchBorderWidth * 2}px;
        `};

        ${media.largeUp`
          top: ${searchHeight}px;
        `};
      `};

    .pj-ui-search--products {
      padding-top: 0;
    }

    ${media.mediumDown`
      padding: 0 ${layout.spacing.small};
    `};
  `
);

export const SearchWrapper = styled.div`
  width: 100%;
`;

export const Search = styled.div(
  props => css`
    width: 100%;
    position: relative;
  `
);
